import { createFileRoute } from '@tanstack/react-router';

import SettingsPage from '@/pages/SettingPage';

export const Route = createFileRoute('/settings')({
  component: SettingsPage,
});
